define("command-palette/utils/is-valid-command-id", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.isValidCommandId = isValidCommandId;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function isValidCommandId(id) {
    // Note: we can loosen the constraints if need be
    const kebabCaseRegex = /^[a-z][a-z0-9-]*[a-z0-9]$/;
    return kebabCaseRegex.test(id);
  }
  var _default = _exports.default = isValidCommandId;
});